import React from "react";
import { Helmet } from "react-helmet-async";
import { useTheme } from "../../context/ThemeContext";
import { getThemeClasses } from "../utils/themeClass";

const About = () => {
  const { theme } = useTheme();
  const themeClass = getThemeClasses(theme);

  return (
    <div className={`${themeClass.bgColor} ${themeClass.baseText} min-h-screen`}>
      <div
        className={`max-w-4xl mx-auto p-6 md:p-10 text-center rounded-xl shadow-lg transition-all duration-300 ${themeClass.overlayBg} ${themeClass.borderColor}`}
      >
        <Helmet>
          <title>About Us | BrowserArena</title>
          <meta
            name="description"
            content="Learn more about BrowserArena, your ultimate destination for free online browser games."
          />
          <script type="application/ld+json">
            {JSON.stringify({
              "@context": "https://schema.org",
              "@type": "AboutPage",
              name: "About BrowserArena",
              url: "https://browserarena.com/about",
              description:
                "Learn more about BrowserArena — your portal for the best free online browser games.",
            })}
          </script>
          <link rel="canonical" href="https://browserarena.com/about" />
        </Helmet>

        <h1 className={`text-3xl sm:text-4xl font-bold mb-6 ${themeClass.titleColor}`}>
          About Us
        </h1>

        <p className={`text-base sm:text-lg mb-4 ${themeClass.overlayText}`}>
          Welcome to{" "}
          <span className={`font-semibold ${themeClass.titleColor}`}>
            BrowserArena
          </span>
          , where fun meets innovation! Our mission is to provide an exciting
          online gaming experience for players of all ages.
        </p>

        <p className={`text-base sm:text-lg mb-4 ${themeClass.overlayText}`}>
          Founded by passionate developers, we continually update our game library
          to ensure fresh, engaging content. Whether you're looking to unwind or
          challenge yourself, we have something for everyone!
        </p>

        <p className={`text-base sm:text-lg mb-6 ${themeClass.overlayText}`}>
          Join our community and explore the endless possibilities of online
          gaming!
        </p>

        <a
          href="/"
          className={`inline-block px-6 py-3 rounded-lg font-semibold text-base sm:text-lg transition-all shadow-md hover:shadow-lg ${themeClass.exploreBtn}`}
        >
          Explore Our Games
        </a>
      </div>
    </div>
  );
};

export default About;
